/* eslint-disable keyword-spacing */
/* eslint-disable func-names */
/* eslint-disable comma-dangle */
/* eslint-disable space-before-function-paren */
import { SAVE_WEATHER_DATA, SAVE_NOTAMS, FETCH_USEFULLINKS, FETCH_AIRPORT_INFORMATION, FETCH_RUNWAY_CONDITIONS } from './types';

const INITIAL_STATE = {
    weather: {},
    notams: [],
    airportInfo: '',
    runwayInfo: [],
    usefulLinks: [],
    tileOrder: []
};
export default function(state=INITIAL_STATE, action) {
    switch(action.type) {
        case SAVE_WEATHER_DATA:
            return {
                ...state,
                weather: action.payload,
            };
        case SAVE_NOTAMS:
            return {
                ...state,
                notams: action.payload
            };
        case FETCH_USEFULLINKS:
            return {
                ...state,
                usefulLinks: action.payload
            };
            case FETCH_AIRPORT_INFORMATION:
                return {
                    ...state,
                    airportInfo: action.payload
                };
                case FETCH_RUNWAY_CONDITIONS:
                    return {
                        ...state,
                        runwayInfo: action.payload.data,
                        tileOrder: action.payload.tileOrder
                    };
        default:
        return state;
    }
}
